import React from 'react';
import { Typography } from '@mui/material';
import { styled } from '@mui/system';

const StyledNotFoundMessage = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[700],
  position: 'absolute',
  top: '50%',
  transform: 'translateY(-50%)',
  left: 0,
  width: '100%',
  '& a': {
    color: theme.palette.getContrastText(theme.palette.secondary.main)
  },
  paddingLeft: 20,
  paddingRight: 20
}));

const NotFoundMessage = props => {
  const { children, ...restProps } = props;
  return (
    <StyledNotFoundMessage
      component="h1"
      variant="h4"
      align="center"
      {...restProps}
    >
      {children}
    </StyledNotFoundMessage>
  );
};

export default NotFoundMessage;
